//
export const projects = [
  // {
  //   projectName: "Linkedin-Clone",
  //   imgUrl:
  //     "linkdin-screenshot.png",
  //   codeUrl: "https://github.com/Ashokzarmariya/linkdin-react",
  //   websiteUrl: "https://linkdin-react.vercel.app/",
  //   about:
  //     "LinkedIn is an American business and employment-oriented online service.This project have following features, user can update his profile data, add post, make comment on post, like post, search user by username, chat with another user, user authentication",
  //   tech: ["TypeScript", "React.js", "MUI", "Tailwindcss", "MongoDB"],
  // },
  {
    projectName: "Whatsapp-Web-Clone",
    imgUrl:
      "https://res.cloudinary.com/zarmariya/image/upload/v1662380600/my%20portfolio/whatapp_clone_sdnqim.png",
    codeUrl: "https://github.com/Ashokzarmariya/whats-app-clone",
    websiteUrl: "http://whats-app-clone-nine.vercel.app/",
    about:
      "WhatsApp is free to download messenger app for smartphones.This project have features, user can update his profile data, search user by name, realtime chatating, user authentication, realtime notification",
    tech: ["Javascript", "React.js", "soket.io", "Tailwindcss", "MongoDB","nodejs"],
  },
  {
    projectName: "Crypto Hustle",
    imgUrl:
      "https://res.cloudinary.com/zarmariya/image/upload/v1655182168/my%20portfolio/crypto-hustle_ibo1bb.png",
    websiteUrl: "http://crypto-hustle.vercel.app/",
    about:
      "Crypto-hustle is the platform where you can track daily, monthly market price of all the crypto currency's,you can also check growth and down via graph, all you need to do is just free signup ",
    tech: ["TypeScript", "Next.js", "MUI", "Tailwindcss", "Chart.js"],
  },
  {
    projectName: "Netflix",
    imgUrl:
      "https://assets.nflxext.com/ffe/siteui/vlv3/d0982892-13ac-4702-b9fa-87a410c1f2da/519e3d3a-1c8c-4fdb-8f8a-7eabdbe87056/AE-en-20220321-popsignuptwoweeks-perspective_alpha_website_large.jpg",
    codeUrl: "https://github.com/Ashokzarmariya/netflix-clone",
    websiteUrl: "https://netflix-clone-by-ashokzarmariya.vercel.app/",
    about:
      "Netflix is an American subscription streaming service and production company.This project have features like random movie carousel, stream trailer, categrize movie, user athentication",
    tech: ["TypeScript", "Next.js", "MUI", "Tailwindcss", "Firebase"],
  },
  {
    projectName: "Problem Manager",
    imgUrl:
      "https://res.cloudinary.com/zarmariya/image/upload/v1655203449/my%20portfolio/problem_manager_duqlhi.png",
      codeUrl: "https://github.com/Ashokzarmariya/team-shoppersstop",
    websiteUrl: "https://problem-manager.vercel.app/",
    about:
      "Problem manager is platform where you can track your dsa problem and practice on time so that you don't forgot them, user can add problem category wise",
    tech: ["react.js", "MUI", "Tailwindcss", "MongoDB","nodejs"],
  },
  {
    projectName: "Shopper Stop",
    imgUrl:
      "https://www.retail4growth.com/public/uploads/editor/2019-07-31/1564548758.jpg",
    codeUrl: "https://github.com/Ashokzarmariya/team-shoppersstop",
    websiteUrl: "https://team-shoppersstop.vercel.app/",
    about:
      "shopperstop is An eCommerce website for lifestyle products.Following feture are implemented like product sorting, Product categorization based on colour, gender, price, brand, etc. Add to cart feature",
    tech: ["Javascript", "HTML 5", "CSS 3", "MongoDb"],
  },
];
